var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M8.49921 5.66732C8.40146 5.66732 8.32213 5.74665 8.32284 5.8444C8.32284 5.94215 8.40217 6.02148 8.49992 6.02148C8.59767 6.02148 8.677 5.94215 8.677 5.8444C8.677 5.74665 8.59767 5.66732 8.49921 5.66732",
    stroke: "#6A6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14.875V14.875C4.97887 14.875 2.125 12.0211 2.125 8.5V8.5C2.125 4.97887 4.97887 2.125 8.5 2.125V2.125C12.0211 2.125 14.875 4.97887 14.875 8.5V8.5C14.875 12.0211 12.0211 14.875 8.5 14.875Z",
    stroke: "#6A6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M8.49992 8.5V12.0417",
    stroke: "#6A6C71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.a39c00b7f89a858d260ee9f050153b02.svg";
export { ForwardRef as ReactComponent };